import { useIsVisible } from "@website/hooks/is-visible";
import {
  FabMenuItemsTypes,
  FabMenuPropertiesTypes
} from "@website/ui/fab-menu/fab-bar.type";
import { useTopBar } from "@website/ui/fab-menu/fab-menu.hook";
import styles from "@website/ui/fab-menu/fab-menu.module.scss";
import { deepCompare } from "@website/utils/deep-compare";
import { memo, useEffect } from "react";

const Component = (properties: FabMenuPropertiesTypes) => {
  const { items, className, eventToTracking } = properties;
  const { scrolledItem, handleClick } = useTopBar(properties);

  const { reference, inView } = useIsVisible();

  useEffect(() => {
    if (
      process.env.NEXT_PUBLIC_APP_NAME === "villa" &&
      scrolledItem === "فضاهای اقامتگاه"
    )
      eventToTracking?.();
  }, [scrolledItem]);

  return (
    <>
      <div className={styles["fake-element"]} ref={reference} />
      <div
        className={`${styles["layout"]} ${className && className} ${
          inView ? "hidden" : "block"
        }`}
      >
        <div className={styles["container"]}>
          {items?.map((item: FabMenuItemsTypes) => (
            <div
              className={`${styles["container__item"]} ${
                scrolledItem === item?.title
                  ? styles["container__item__clicked"]
                  : styles["container__item__not-clicked"]
              }`}
              key={item.selector}
              onClick={handleClick(item)}
            >
              {item.title}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export const FabMenu = memo(Component, deepCompare);
